import { c as _c } from "react/compiler-runtime";
import { SingleSelectAutocomplete } from "@flat-ui";
/**
 * flat-ui's autocomplete is driven by `{ title, value }` options rather than by arbitrary objects,
 * so the entities are mapped across on the way in and looked back up by id on the way out. The id
 * is unique per integration entity, which is what makes the round trip lossless.
 *
 * @param entity The integration entity to describe as an option
 * @returns The entity as an option flat-ui's autocomplete understands
 */
function toOption(entity) {
  return {
    title: entity.name,
    value: entity.id
  };
}

/** Renders autocomplete for integration entry */
export function IntegrationAutocomplete(t0) {
  const $ = _c(15);
  const {
    value,
    options,
    noOptionsText,
    onChange,
    shouldDisabled: t1,
    shouldFocus: t2,
    placeholder
  } = t0;
  const shouldDisabled = t1 === undefined ? false : t1;
  const shouldFocus = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== value) {
    t3 = value ? toOption(value) : null;
    $[0] = value;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== options) {
    t4 = options.map(toOption);
    $[2] = options;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onChange || $[5] !== options) {
    t5 = newValue => {
      const selected = typeof newValue === "string" ? null : newValue;
      onChange(options.find(option => option.id === selected?.value) ?? null);
    };
    $[4] = onChange;
    $[5] = options;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== noOptionsText || $[8] !== placeholder || $[9] !== shouldDisabled || $[10] !== shouldFocus || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <SingleSelectAutocomplete value={t3} options={t4} noOptionsText={noOptionsText} placeholder={placeholder} isDisabled={shouldDisabled} hasAutoFocus={shouldFocus} showIcon={false} showSelectedCheckmark={true} onChange={t5} />;
    $[7] = noOptionsText;
    $[8] = placeholder;
    $[9] = shouldDisabled;
    $[10] = shouldFocus;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}